export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14639.067e13b2.jpg";